import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import styles from "../../styles/public/cancellation-modal.module.css";

const CancellationModal = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} toggle={onClose}>
      <ModalHeader
        toggle={onClose} // Use toggle prop for close button
        className={`${styles["custom-modal-header"]} d-flex justify-content-center align-items-center`}
      >
        <span className={styles["modal-title"]}>Our Cancellation Policy</span>
      </ModalHeader>
      <ModalBody>
        <div className="d-flex align-items-center">
          <img src="/img/golf-hole.png" alt="Golf hole" className={styles["modal-body-image"]} />
          <p className={styles["modal-body-text"]}>
            We ask that you please reschedule or cancel before the beginning of your appointment.
          </p>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CancellationModal;